<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("customer", 2) }}
      </div>
      <div>
        <router-link class="btn-blue" to="customers"
          >{{ $tc("customer", 2) }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="customerDetails.first_name"
                v-validate="{ required: 'required', regex: /^[a-zA-Z ]*$/ }"
                name="firstname"
                id="firstname"
              />
              <label> {{ $t("first_name") }}</label>
            </div>
            <Tooltip :title="$t('first_name')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('firstname')">{{
              errors.first("firstname")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="customerDetails.last_name"
                name="last_name"
                id="last_name"
              />
              <label>{{ $t("last_name") }}</label>
            </div>
            <Tooltip :title="$t('last_name')" />
          </div>
          <p class="error_message"></p>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." type="text" name />
              <label>{{ $tc('customer', 1) }} {{ $t('code') }}</label>
            </div>
            <Tooltip :title="``"  />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>-->

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-validate="'required|email'"
                v-model="customerDetails.cust_email"
                name="cust_email"
                id="cust_email"
              />
              <label>{{ $t("email") }}</label>
            </div>
            <Tooltip :title="$t('customerEmail')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('cust_email')">{{
              errors.first("cust_email")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material row">
              <div class="col-4">
                <b-dropdown
                  :text="
                    customerDetails.country_code
                      ? customerDetails.country_code
                      : 'Code'
                  "
                  variant="dropdown-curve"
                  class="w-100 text-center mr-3"
                  placeholder="code"
                  name="countrycode"
                  id="countrycode"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Code"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCode($event.target.value)"
                      v-on:keydown="onSearchCode($event.target.value)"
                      v-on:search="onSearchCode($event.target.value)"
                      v-model="searchCode"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(countrycode, countryIndex) in countryList"
                    :key="countryIndex"
                    v-on:click="onSelectHandler('countrycode', countrycode)"
                    v-if="countrycode.country_mob_code != null"
                    >{{ countrycode.country_mob_code }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="col-8 pl-1">
                <input
                  placeholder="."
                  type="text"
                  v-model="customerDetails.cust_mobile"
                  v-validate="'required|numeric|min:6|max:15'"
                  name="cust_mobile"
                  id="cust_mobile"
                />
                <label>{{ $t("mobiles") }}</label>
              </div>
            </div>
            <Tooltip :title="$t('customerMobile')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && !customerDetails.country_code">{{
              "Country Code is Required."
            }}</span>
            <span>{{ " " }}</span>
            <span v-if="submitted && errors.has('cust_mobile')">{{
              errors.first("cust_mobile")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="typeof customerDetails.cust_doj === 'object'"
                  v-on:click="clearDOJDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="customerDetails.cust_doj"
                  name="doj"
                  id="doj"
                  :typeable="true"
                ></Datepicker>
                <label
                  :class="
                    typeof customerDetails.cust_doj === 'object' ? 'active' : ''
                  "
                  >{{ $t("doj") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('customerDoj')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="typeof customerDetails.cust_dob === 'object'"
                  v-on:click="clearDOBDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="customerDetails.cust_dob"
                  name="dob"
                  id="dob"
                  :typeable="true"
                ></Datepicker>
                <label
                  :class="
                    typeof customerDetails.cust_dob === 'object' ? 'active' : ''
                  "
                  >{{ $t("dob") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('customerDob')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="
                    typeof customerDetails.cust_anniversary_date === 'object'
                  "
                  v-on:click="clearAnniversaryDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="customerDetails.cust_anniversary_date"
                  name="anniversary_date"
                  id="anniversary_date"
                  :typeable="true"
                ></Datepicker>
                <label
                  :class="
                    typeof customerDetails.cust_anniversary_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $t("anniversary") }} {{ $t("date") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('customeranniversarydate')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Institution.length > 0 ? 'shift-up' : ''">{{
              $tc("institution")
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Institution"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(institution, institutionIndex) in Institutions"
                  :key="institutionIndex"
                  v-on:click="onSelectHandler('institution', institution)"
                  name="selectinstitution"
                  id="selectinstitution"
                  >{{ institution.institution_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('customerInstitution')" />
            </div>
            <p class="error_message">
              <span>{{ msgcinema }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.User.length > 0 ? 'shift-up' : ''"
              >{{ $tc("user", 1) }} {{ $tc("category", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.User"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(user, userIndex) in Users"
                  :key="userIndex"
                  v-on:click="onSelectHandler('user', user)"
                  name="selectuser"
                  id="selectuser"
                  >{{ user.buc_category_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('customerusercategory')" />
            </div>
            <p class="error_message">
              <span>{{ msgcinema }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="customerDetails.cust_address"
                name="cust_address"
                id="cust_address"
              />
              <label>{{ $t("address") }}</label>
            </div>
            <Tooltip :title="$t('customerAddress')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

         <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="customerDetails.cust_pan"
                name="cust_pan"
                id="cust_pan"
              />
              <label>{{ 'PAN No.' }}</label>
            </div>
            <Tooltip :title="'Customer PAN Number'" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Country.length > 0 ? 'shift-up' : ''">{{
              $tc("country", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(country, countryIndex) in Countries"
                  :key="countryIndex"
                  v-on:click="onSelectHandler('country',country)"
                  name="selectcountry"
                  id="selectcountry"
                >{{ country.country_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="Countries"
                v-model="selected_country"
                :searchable="true"
                label="country_name"
                track-by="country_name"
                placeholder="."
                @input="onSelectHandler('country', $event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$t('customerCountry')" />
            </div>
            <p class="error_message">
              <span>{{ msgcinema }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.State.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("state", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(state, stateIndex) in States"
                  :key="stateIndex"
                  @click="onSelectHandler('state',state)"
                  name="selectstate"
                  id="selectstate"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="States"
                v-model="selected_state"
                :searchable="true"
                label="state_name"
                track-by="state_name"
                placeholder="."
                :allowEmpty="false"
                :showLabels="false"
                @input="onSelectHandler('state', $event)"
              ></multiselect>
              <Tooltip :title="$t('customerSelectState')" />
            </div>
            <p class="error_message">
              <span>{{ msgcinema }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.City.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("city", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(city,cityIndex) in Cities"
                  :key="cityIndex"
                  @click="onSelectHandler('city',city)"
                  name="selectcity"
                  id="selectcity"
                >{{ city.city_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="Cities"
                v-model="selected_city"
                :searchable="true"
                label="city_name"
                track-by="city_name"
                placeholder="."
                :allowEmpty="false"
                :showLabels="false"
                @input="onSelectHandler('city', $event)"
              ></multiselect>
              <Tooltip :title="$t('customerSelectCity')" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mr-3"
              >{{ $tc("customer", 1) }} {{ $t("verified") }}</label
            >
            <b-form-checkbox
              v-model="customerDetails.cust_verified"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
          </div>

          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center mr-3">
            <label class="mr-2">{{ $t("customerisactive") }}</label>
            <b-form-checkbox
              v-model="customerDetails.cust_is_active"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
          </div>

          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="customers">{{
            $t("cancel")
          }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
export default {
  data() {
    return {
      selected_country: null,
      selected_state: null,
      selected_city: null,
      btenable: false,
      selected: {
        Institution: "",
        User: "",
        Country: "",
        State: "",
        City: ""
      },
      msgcinema: "",
      submitted: false,
      isRoleID: true,
      customerDetails: {
        cust_name: null,
        first_name: null,
        last_name: null,
        cust_code: null,
        cust_email: null,
        cust_mobile: null,
        cust_doj: "",
        cust_dob: null,
        cust_pan: null,
        cust_anniversary_date: null,
        institution_id: null,
        booking_user_category_id: null,
        cust_address: null,
        city_id: null,
        state_id: null,
        country_id: null,
        cust_verified: "N",
        cust_is_active: "N",
        country_code: "",
        preferred_lang_id: 1,
        is_pos_registration: 'Y',
      },

      Institutions: [],
      InstitutionsMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_institutions",
        urlKey: "institutions"
      },
      Users: [],
      UserssMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_booking_user_categories",
        urlKey: "booking_user_categories"
      },
      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states"
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: ""
    };
  },
  beforeMount() {
    this.getCountriesList();
    this.getInstitutionsList();
    this.getUsersList();
  },
  mounted() {
    // const { bank_id } = this.$route;
  },
  methods: {
    onResetForm: function() {
      this.customerDetails = {
        cust_name: null,
        first_name: null,
        last_name: null,
        cust_code: null,
        cust_email: null,
        cust_mobile: null,
        cust_doj: "",
        cust_dob: null,
        cust_anniversary_date: null,
        institution_id: null,
        booking_user_category_id: null,
        cust_address: null,
        city_id: null,
        state_id: null,
        country_id: null,
        cust_verified: "N",
        cust_is_active: "N",
        country_code: "",
        preferred_lang_id: 1,
        is_pos_registration: 'Y',
      };
      this.selected = {
        Institution: "",
        User: "",
        Country: "",
        State: "",
        City: ""
        // date_Of_Join: "",
        // date_Of_Birth: "",
        // anniversary_date: "",
        // user_category: ""
      };
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter(x => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    getCountriesList: function() {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.countryList = data.Records;
            this.CodeListCopy = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStatesList: function(cid) {
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: cid
      };
      MasterService.GetActiveList(payload)
        // this.States = [];
        // let body = this.getRequestBody("GET", undefined, {
        //   ...this.StatesMethod,
        //   params: { id: "country_id-" + country_id }
        // });
        // MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.States = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCitiesList: function(s_id) {
      this.Cities = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: s_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getInstitutionsList: function() {
      this.Institutions = [];
      let payload = {
        tableName: "ms_institutions",
        institution_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Institutions = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getUsersList: function() {
      this.Users = [];
      let payload = {
        tableName: "ms_booking_user_categories",
        buc_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function(type, value) {
      if (type == "country") {
        // console.log("value :", value);
        this.selected.country_id = value.country_id;
        this.selected.Country = value.country_name;
        this.customerDetails.country_id = value.country_id;
        this.selected.State = "";
        this.customerDetails.state_id = null;
        this.selected.City = "";
        this.customerDetails.city_id = null;
        this.Cities = [];
        this.selected_state = null;
        this.selected_city = null;
        this.customerDetails.country_code = value.country_mob_code;
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        (this.selected.State = value.state_name),
          (this.customerDetails.state_id = value.state_id);
        this.selected.City = "";
        this.customerDetails.city_id = null;
        this.selected_city = null;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        (this.selected.City = value.city_name),
          (this.customerDetails.city_id = value.city_id);
      } else if (type == "institution") {
        (this.selected.Institution = value.institution_name),
          (this.customerDetails.institution_id = value.institution_id);
      } else if (type == "user") {
        (this.selected.User = value.buc_category_name),
          (this.customerDetails.booking_user_category_id = value.buc_id);
      } else if (type == "countrycode") {
        this.customerDetails.country_code = value.country_mob_code;
      }
    },
    clearDOBDate: function() {
      this.customerDetails.cust_dob = "";
    },
    clearDOJDate: function() {
      this.customerDetails.cust_doj = "";
    },
    clearAnniversaryDate: function() {
      this.customerDetails.cust_anniversary_date = "";
    },

    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator
        .validate()
        .then(valid => {
          if (valid) {
            this.btenable = true;
            if (!this.customerDetails.country_code) {
              return;
            }
            this.customerDetails.cust_name =
              this.customerDetails.first_name +
              " " +
              this.customerDetails.last_name;
            MarketingService.addCustomer({ ...this.customerDetails }).then(
              response => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  this.$toasted.show(data.message);

                  this.onResetForm();
                  if (redirect) {
                    // console.log("redirect value ", redirect);
                    this.$router.push({
                      path: "/marketing/customers"
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              }
            );
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomersComponents/addCustomers.vue